export default "__VITE_ASSET__b4ae419e__"